import { render, staticRenderFns } from "./userRegister.vue?vue&type=template&id=d538d726"
import script from "./userRegister.vue?vue&type=script&lang=js"
export * from "./userRegister.vue?vue&type=script&lang=js"
import style0 from "./userRegister.vue?vue&type=style&index=0&id=d538d726&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UserHeader: require('/root/workspace/web-company_Yo6Q/components/userLogin/userHeader.vue').default,UserCountry: require('/root/workspace/web-company_Yo6Q/components/userLogin/userCountry.vue').default,UserGraphical: require('/root/workspace/web-company_Yo6Q/components/userLogin/userGraphical.vue').default,UserThreparty: require('/root/workspace/web-company_Yo6Q/components/userLogin/userThreparty.vue').default})
